import React, { useEffect, useState } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Editor } from 'primereact/editor';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Calendar } from 'primereact/calendar';
import './BitacorasPorTurno.scss';
import TitleView from "../../../components/atoms/TitleView/TitleView";
import useGetDataUser from "../../../CustomHooks/useGetDataUser";
import { formateoBasico } from "../../../utilities/formateos";
import { crearReportePorTurno, getBitacorasPorTurno, getReportes, updateReporte } from "./integracion";
import Swal from "sweetalert2";


const BitacorasPorTurno = () => {
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [fecha, setFecha] = useState(formateoBasico(new Date()));
    const [turno, setTurno] = useState(1);
    const [nota, setNota] = useState('');
    const [visible, setVisible] = useState(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [selectedReporte, setSelectedReporte] = useState(null);
    const [notaEdit, setNotaEdit] = useState('');
    const userInfo = useGetDataUser();
    const [bitacoras, setBitacoras] = useState([]);
    const [reportes, setReportes] = useState([]);

    useEffect(() => {
        getInfo();
    }, []);
    useEffect(() => { }, [reportes]);
    const getInfo = async () => {
        await getReportes({ fecha_inicio: formateoBasico(fechaInicio), fecha_fin: formateoBasico(fechaFin) }).then((data) => {
            setReportes(data);
        });
        await getBitacorasPorTurno(fecha).then((data) => {
            setBitacoras(data);
        });

    };

    const handleBuscar = async () => {
        await getInfo();
    };

    const handleGuardar = () => {
        const id_usuario = userInfo?.ID;

        if (!nota) {
            Swal.fire({
                icon: 'warning',
                title: 'La nota no puede estar vacía',
                confirmButtonText: 'OK'
            });
            return;
        }

        crearReportePorTurno({ turno: turno, reporte: nota, usuario: id_usuario })
            .then((data) => {
                Swal.fire({
                    icon: 'success',
                    title: 'Reporte guardado correctamente',
                    confirmButtonText: 'OK'
                });
                setVisible(false);
                setNota('');
                // Recargar datos
                getInfo();
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar el reporte',
                    text: error.message,
                    confirmButtonText: 'OK'
                });
            });
    };

    const handleOpenEdit = (rowData) => {
        setSelectedReporte(rowData);
        setNotaEdit(rowData.reporte);
        setVisibleEdit(true);
    };

    const handleGuardarEdit = async () => {
        if (!notaEdit) {
            Swal.fire({
                icon: 'warning',
                title: 'La nota no puede estar vacía',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Aquí deberías llamar a tu API de actualización
       await updateReporte({ id: selectedReporte.id, reporte: notaEdit })
            // Por ahora simulo una actualización exitosa
            .then(() => {
                Swal.fire({
                    icon: 'success',
                    title: 'Reporte actualizado correctamente',
                    confirmButtonText: 'OK'
                });
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al actualizar el reporte',
                    text: error.message,
                    confirmButtonText: 'OK'
                });
            });
        setVisibleEdit(false);
        setNotaEdit('');
        setSelectedReporte(null);
        // Recargar datos
        await getInfo();
    };

    const reporteBodyTemplate = (rowData) => {
        return (
            <div
                dangerouslySetInnerHTML={{ __html: rowData.reporte }}
                style={{ maxWidth: '400px', overflow: 'hidden', textOverflow: 'ellipsis' }}
            />
        );
    };

    const accionesBodyTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-pencil"
                className="p-button-rounded p-button-info"
                onClick={() => handleOpenEdit(rowData)}
                tooltip="Ver/Editar"
                tooltipOptions={{ position: 'top' }}
            />
        );
    };

    return (
        <div className="bitacoras-por-turno">
            <TitleView title="Bitácoras por Turno" />

            <div className="main-content">
                <div className="table-container">
                    <div className="table-card">
                        <div className="filters-section">
                            <div className="table-header-actions">
                                <Button
                                    label="Crear Reporte"
                                    icon="pi pi-plus"
                                    onClick={() => setVisible(true)}
                                    className="create-button"
                                />
                            </div>
                            <div className="filters-group">
                                <div className="filter-field">
                                    <label htmlFor="fecha-inicio">Fecha Inicio</label>
                                    <Calendar
                                        id="fecha-inicio"
                                        value={fechaInicio}
                                        onChange={(e) => setFechaInicio(e.value)}
                                        dateFormat="dd/mm/yy"
                                        showIcon
                                        placeholder="Selecciona fecha inicio"
                                    />
                                </div>

                                <div className="filter-field">
                                    <label htmlFor="fecha-fin">Fecha Fin</label>
                                    <Calendar
                                        id="fecha-fin"
                                        value={fechaFin}
                                        onChange={(e) => setFechaFin(e.value)}
                                        dateFormat="dd/mm/yy"
                                        showIcon
                                        placeholder="Selecciona fecha fin"
                                    />
                                </div>

                                <div className="filter-actions">
                                    <Button
                                        label="Buscar"
                                        icon="pi pi-search"
                                        onClick={handleBuscar}
                                        className="search-button"
                                    />
                                </div>
                            </div>


                        </div>

                        <DataTable
                            value={reportes}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            className="bitacoras-table"
                            emptyMessage="No hay reportes registrados"
                            stripedRows
                            scrollHeight="calc(100vh - 490px)"
                            scrollable
                        >
                            <Column
                                field="id"
                                header="ID"
                                sortable
                                style={{ width: '80px' }}
                            />
                            <Column
                                field="fecha"
                                header="FECHA"
                                sortable
                                style={{ width: '150px' }}
                            />
                            <Column
                                field="usuario"
                                header="USUARIO"
                                sortable
                                style={{ width: '150px' }}
                            />
                            {/* <Column
                                field="reporte"
                                header="REPORTE"
                                sortable
                                style={{ minWidth: '300px' }}
                                body={reporteBodyTemplate}
                            /> */}
                            <Column
                                header="ACCIONES"
                                body={accionesBodyTemplate}
                                style={{ width: '100px', textAlign: 'center' }}
                            />
                        </DataTable>
                    </div>
                </div>

                <div className="bitacoras-list">
                    <h2 className="list-title">Notas del Día</h2>
                    <div className="cards-grid">
                        {bitacoras.map((bitacora) => (
                            <Card key={bitacora.ID_BITACORA} className="bitacora-card">
                                <div className="card-header">
                                    <span className="bitacora-id">ID BITÁCORA: {bitacora.ID_BITACORA}</span>
                                    <span className="bitacora-fecha">{bitacora.HORA}</span>
                                </div>

                                <div className="card-content">
                                    <div
                                        className="bitacora-nota"
                                        dangerouslySetInnerHTML={{ __html: bitacora.NOTA }}
                                    />
                                </div>

                                <div className="card-footer">
                                    <div className="info-item">
                                        <i className="pi pi-user"></i>
                                        <span>Registrado por: <strong>{bitacora.USUARIO_REGISTRO}</strong></span>
                                    </div>
                                    {bitacora.USUARIO_REVISION && (
                                        <div className="info-item">
                                            <i className="pi pi-check-circle"></i>
                                            <span>Revisado por: <strong>{bitacora.USUARIO_REVISION}</strong></span>
                                        </div>
                                    )}
                                </div>
                            </Card>
                        ))}
                    </div>
                </div>
            </div>

            <Dialog
                header="Crear Reporte"
                visible={visible}
                style={{ width: '50vw' }}
                onHide={() => setVisible(false)}
                className="bitacora-dialog"
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            >
                <div className="dialog-content-reporte">
                    <div className="user-info-modal">
                        <span className="user-label">Registrado por:</span>
                        <span className="user-name-modal">{userInfo?.NOMBRE}</span>
                    </div>

                    <div className="form-field-modal">
                        <label htmlFor="editor-modal">Registro de Bitácora</label>
                        <Editor
                            id="editor-modal"
                            value={nota}
                            onTextChange={(e) => setNota(e.htmlValue)}
                            style={{ height: '300px' }}
                            placeholder="Escribe las notas del turno..."
                        />
                    </div>

                    <div className="form-actions-modal">
                        <Button
                            label="Cancelar"
                            icon="pi pi-times"
                            onClick={() => setVisible(false)}
                            className="p-button-secondary cancel-button"
                        />
                        <Button
                            label="Guardar"
                            icon="pi pi-save"
                            onClick={handleGuardar}
                            className="save-button-modal"
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Editar Reporte"
                visible={visibleEdit}
                style={{ width: '50vw' }}
                onHide={() => {
                    setVisibleEdit(false);
                    setSelectedReporte(null);
                    setNotaEdit('');
                }}
                className="bitacora-dialog"
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            >
                <div className="dialog-content-reporte">
                    {selectedReporte && (
                        <>
                            <div style={{ fontSize: '0.85rem', color: '#666', marginBottom: '15px', display: 'flex', gap: '20px' }}>
                                <span>ID: <strong>{selectedReporte.id}</strong></span>
                                <span>Fecha: <strong>{selectedReporte.fecha}</strong></span>
                                <span>Usuario: <strong>{selectedReporte.NOMBRE_USUARIO}</strong></span>
                            </div>

                            <div className="form-field-modal">
                                <label htmlFor="editor-modal-edit">Editar Reporte</label>
                                <Editor
                                    id="editor-modal-edit"
                                    value={notaEdit}
                                    onTextChange={(e) => setNotaEdit(e.htmlValue)}
                                    style={{ height: '300px' }}
                                    placeholder="Edita el contenido del reporte..."
                                />
                            </div>

                            <div className="form-actions-modal">
                                <Button
                                    label="Cancelar"
                                    icon="pi pi-times"
                                    onClick={() => {
                                        setVisibleEdit(false);
                                        setSelectedReporte(null);
                                        setNotaEdit('');
                                    }}
                                    className="p-button-secondary cancel-button"
                                />
                                <Button
                                    label="Guardar Cambios"
                                    icon="pi pi-save"
                                    onClick={handleGuardarEdit}
                                    className="save-button-modal"
                                />
                            </div>
                        </>
                    )}
                </div>
            </Dialog>
        </div>
    );
};

export default BitacorasPorTurno;